export const NOVA_AI_ORIGIN = 'https://ai.novays.cn'
export const NOVA_AI_URL = `${NOVA_AI_ORIGIN}/`
export const NOVA_AI_SSO_URL = `${NOVA_AI_ORIGIN}/auth/yudao`
